import { render } from "./TiresType.vue?vue&type=template&id=67b3fd3f&scoped=true"
import script from "./TiresType.vue?vue&type=script&lang=js"
export * from "./TiresType.vue?vue&type=script&lang=js"

import "./TiresType.vue?vue&type=style&index=0&id=67b3fd3f&scoped=true&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b3fd3f"]])

export default __exports__